export default __webpack_public_path__ + "static/logo-02cb28fe3a988db75a5cef77fa1db902.png";